module.exports = __webpack_public_path__ + "img/16b2073.svg";